export interface CommonEcwComponentProps {
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface EcwFormValues {
    patID: string;
    barcode: string;
    qty: number;
    units: string;
    waste: number;
    accessKey?: string,
    patFName?: string,
    patMName?: string,
    patLName?: string,
    patDOB?: string,
    patGender?: string,
    userID?: string,
    userFName?: string,
    userMName?: string,
    userLName?: string,
    userNum?: string,
    hcpid?: string,
    hcpfName?: string,
    hcpmName?: string,
    hcplName?: string,
    hcpNum?: string,
    serverDate?: string,
    serverTime?: string,
    location?: string,
    query?: string,
    uniqueId?: string,
    inventory?: boolean,
    expiringInventory?: boolean,
    emrOrderId?: string,
    name?: string,
    encounterId?: string,
    encounterDate?: string,
    emrOrderDate?: string,
    reason?: string | null,
    clientId?: string,
    orderId: string | number;
    orderType: string;
    route: string;
    site: string;
    facilityGuid?: string,
    facilityName?: string,
    itemInfo: {
        lotNumber?: string,
        expiration?: string,
        ndcCode?: string,
        manufacturer?: string,
        manufacturerEcwCode?: string | null,
        cvXCode?: string,
        mvxCode?: string,
        mvxManufacturer?: string,
        stock?: string,
        itemName?: string,
        itemType?: string,
    }
}

export const EcwFormInitialValues: EcwFormValues = {
    patID: "",
    barcode: "",
    qty: 0,
    units: "",
    waste: 0,
    accessKey: "",
    patFName: "",
    patMName: "",
    patLName: "",
    patDOB: "",
    patGender: "",
    userID: "",
    userFName: "",
    userMName: "",
    userLName: "",
    userNum: "",
    hcpid: "",
    hcpfName: "",
    hcpmName: "",
    hcplName: "",
    hcpNum: "",
    serverDate: "",
    serverTime: "",
    location: "",
    query: "",
    uniqueId: "",
    inventory: true,
    expiringInventory: true,
    emrOrderId: "",
    name: "",
    encounterId: "",
    encounterDate: "",
    emrOrderDate: "",
    reason: null,
    clientId: "",
    orderId: "",
    orderType: "",
    route: "",
    site: "",
    facilityGuid: "",
    facilityName: "",
    itemInfo: {
        lotNumber: "",
        expiration: "",
        ndcCode: "",
        manufacturer: "",
        manufacturerEcwCode: "",
        cvXCode: "",
        mvxCode: "",
        mvxManufacturer: "",
        stock: "",
        itemName: "",
        itemType: "",
    }
}

export const AddPatientFormInitialValues = {
    firstName: "",
    lastName: "",
    dob: null as Date | null,
    gender: "",
    patientCode: "",
    isActive: true,
}

export const genderOptions: string[] = ["Male", "Female", "Other"];

export const OrderTypeOptions: { value: string, label: string }[] = [
    { value: "VAC", label: "Vaccine" },
    { value: "MED", label: "Medication" },
    { value: "THINJ", label: "Therapeutic injection" },
    { value: "DME", label: "DME" }
];

export const RouteFieldOptions = [
    { value: "", label: "Please select route" },
    { value: "ID", label: "Intradermal" },
    { value: "IM", label: "Intramuscular" },
    { value: "NS", label: "Nasal" },
    { value: "IV", label: "Intravenous" },
    { value: "PO", label: "Oral" },
    { value: "OTH", label: "Other/Miscellaneous" },
    { value: "SC", label: "Subcutaneous" },
    { value: "TD", label: "Transdermal" },
    { value: "NA", label: "NA" }
]

export const RouteFieldOptionsThinj = [
    { value: "", label: "Please select route" },
    { value: "IDINJ", label: "Intradermal" },
    { value: "IM", label: "Intramuscular" },
    { value: "NASINHLC", label: "Nasal" },
    { value: "IVINJ", label: "Intravenous" },
    { value: "PO", label: "Oral" },
    { value: "SQ", label: "Subcutaneous" },
    { value: "TRNSDERM", label: "Transdermal" }
]

export const SiteFieldOptions = [
    { value: "", label: "Please select site" },
    { value: "BN", label: "Bilateral Nares" },
    { value: "LA", label: "Left Arm" },
    { value: "LD", label: "Left Deltoid" },
    { value: "LG", label: "Left Gluteus Medius" },
    { value: "LLFA", label: "Left Lower Forearm" },
    { value: "LN", label: "Left Nares" },
    { value: "LPC", label: "Left Posterior Chest" },
    { value: "LT", label: "Left Thigh" },
    { value: "LVL", label: "Left Vastus Lateralis" },
    { value: "RA", label: "Right Arm" },
    { value: "RD", label: "Right Deltoid" },
    { value: "RG", label: "Right Gluteus Medius" },
    { value: "RLFA", label: "Right Lower Forearm" },
    { value: "RN", label: "Right Nares" },
    { value: "RPC", label: "Right Posterior Chest" },
    { value: "RT", label: "Right Thigh" },
    { value: "RVL", label: "Right Vastus Lateralis" },
    { value: "NA", label: "NA" }
]
export interface EcwOrdersResponse {
    patientMRN?: string;
    firstName?: string;
    lastName?: string;
    gender?: string;
    birthDate?: string;
    orders?: EcwOrder[];
}

export interface EcwOrder {
    facility: {
        facilityId: string;
        facilityName: string;
    };
    loggedUser: {
        lastName: string;
        firstName: string;
        username: string;
    };
    doses: string;
    cvxCode: string;
    provider: {
        npi: string;
        lastName: string;
        firstName: string;
    };
    vfcCode: string;
    encounterDate: string;
    emrJsonId: number;
    encounterId: number;
    vaccineName: string;
    immId: number;
    status: string;
    colour: string;
    ecwResponseMessage?: string | null;
    isSuccess?: boolean | null;
    orderType?: string | null;
    id?: string;
    medicationRequest?: {
        fhirId: string;
        intent: string;
        authoredOn: string;
        dosageInstruction: string;
        rxOrderNo: string;
        additionalInstruction: string;
        timingStart: string;
        timingCode: string;
        route: string;
        dosage: number;
        dosageUnit: string;
        medicationId: string | null;
        medicationName: string;
        ndcCode: string;
        rxNormCode: string;
        ecwOrderId: string;
        ecwOrder: any;
        id: string;
        isActive: boolean;
        createdOnUtc: string;
        updatedOnUtc: string | null;
        createdBy: string;
        updatedBy: string | null;
    };
    medicationAdministration?: {
        fhirId?: string;
        effectiveDateTime?: string;
        medicationType?: string;
        patientDoseNumber?: number;
        route?: string;
        site?: string;
        method?: string;
        dosage?: number;
        dosageUnit?: string;
        lotNumber?: string;
        medicationName?: string;
        medicationCode?: string;
        medicationCodeSystem?: string;
        ecwOrderId?: string;
        id?: string;
        isActive?: boolean;
        createdOnUtc?: string;
        updatedOnUtc?: string | null;
        createdBy?: string;
        updatedBy?: string | null;
    };
}

export interface EcwOrderResponse {
    isOrderProcessed: boolean;
    ecwResponseMessage: string | null;
}

export interface RecordApiMessages {
    success: string;
    error: string[];
}

export const displayInfo = (value: unknown): string => {
    const text = value == null ? "" : String(value).trim();
    return text || "-";
};

export const getOrderIdDisplay = (order: EcwOrder | null | undefined): string => {
    if (!order) return "";
    if (order?.orderType === 'THINJ' && order?.medicationAdministration) {
        const adminOrderId = order.medicationAdministration?.fhirId;
        if (adminOrderId) {
            return `MA-${adminOrderId.slice(-5)}`;
        }
    }
    const key = getOrderKey(order);
    return key !== undefined && key !== null ? String(key) : "";
};

export const getOrderKey = (order: EcwOrder | null | undefined): string | number | undefined =>
    order?.immId || order?.medicationRequest?.rxOrderNo || order?.medicationAdministration?.fhirId;

export const getRevisedSiteRouteValue = (field: 'site' | 'route', orderType: string, currentValue: string): string => {
    if (orderType !== 'MED') return currentValue;
    const siteLabelMap = new Map(SiteFieldOptions.map(({ value, label }) => [value, label]));
    const routeLabelMap = new Map(RouteFieldOptions.map(({ value, label }) => [value, label]));

    const label = (field === 'site' ? siteLabelMap : routeLabelMap).get(currentValue);

    return label && label !== currentValue ? `${currentValue} (${label})` : currentValue;
};

type Option = { label?: string; value?: string };

export const findMatchedOption = <T extends Option>(value: string | undefined, options: T[]): T | undefined => {
    const target = value?.toLowerCase();
    if (!target) return undefined;

    return options.find((item) => item?.label?.toLowerCase() === target || item?.value?.toLowerCase() === target);
};

export const getSiteDetails = (siteValue?: string) => {
    const matched = findMatchedOption(siteValue, SiteFieldOptions);
    return {
        siteCode: matched?.value ?? siteValue ?? "",
        siteName: (matched && matched.value) ? (matched.label ?? "") : (siteValue ?? ""),
    };
};

export const getRouteDetails = (routeValue?: string, orderType?: string) => {
    const routeOptions = orderType === "THINJ" ? RouteFieldOptionsThinj : RouteFieldOptions;
    const matched = findMatchedOption(routeValue, routeOptions)
        || findMatchedOption(routeValue, RouteFieldOptions)
        || findMatchedOption(routeValue, RouteFieldOptionsThinj);

    return {
        routeCode: matched?.value ?? routeValue ?? "",
        routeName: (matched && matched.value) ? (matched.label ?? "") : (routeValue ?? ""),
    };
};

export interface SelectUnitOption {
    value: string;
    label: string;
    isDefault: boolean;
}

export interface EcwEncounterDetails {
    encounterId: string;
    encounterCode: string;
    status: string;
    startDate: string;
    location: {
        locationId: string;
        name: string;
        phoneNumber: string;
    }
}

export const ECW_THINJ_BLOCKED_MESSAGE = {
    fullText: "selected order has administration data, it can not processed. Details",
    prefix: "selected order has administration data, it can not processed. ",
    linkText: "Details",
    suffix: "",
};

export const THINJ_ADMIN_VALIDATION_STRATEGY: 'ANY' | 'ALL' = 'ANY';

export const isValuePresent = (val: unknown): boolean => {
    if (val === null || val === undefined) return false;
    if (typeof val === 'number') return !isNaN(val) && val > 0;
    const str = String(val).trim();
    return str.length > 0;
};

export const isOrderAdministered = (order: EcwOrder | null | undefined): boolean => {
    if (!order) return false;
    const orderStatus = order.status?.toLowerCase().trim();
    const isGreen = order.colour?.toLowerCase() === 'green';

    return (orderStatus === 'administered' && isGreen) || orderStatus === 'administered';
};

export const hasCompleteStatusKeyword = (status?: string | null): boolean => {
    if (!status) return false;
    return status.toLowerCase().includes('complete');
};

export interface ThinjAdminDataCheckResult {
    isBlocked: boolean;
    hasAdminData: boolean;
    hasStatusViolation: boolean;
    strategy: 'ANY' | 'ALL';
    fields: {
        site: boolean;
        route: boolean;
        qty: boolean;
        unit: boolean;
        ndc: boolean;
        lotNumber: boolean;
        statusOk: boolean;
    };
}

export const checkThinjOrderAdministrationData = (order: EcwOrder | null | undefined, strategy: 'ANY' | 'ALL' = THINJ_ADMIN_VALIDATION_STRATEGY): ThinjAdminDataCheckResult => {
    if (!order || order.orderType !== 'THINJ') {
        return {
            isBlocked: false,
            hasAdminData: false,
            hasStatusViolation: false,
            strategy,
            fields: {
                site: false,
                route: false,
                qty: false,
                unit: false,
                ndc: false,
                lotNumber: false,
                statusOk: true,
            },
        };
    }

    const medAdmin = order.medicationAdministration;

    // If the order is already administered, it is handled as an already processed order (isSelectedOrderProcessed).
    // Do not trigger the THINJ pre-administration conflict alert message for already administered records.
    if (isOrderAdministered(order)) {
        return {
            isBlocked: false,
            hasAdminData: false,
            hasStatusViolation: false,
            strategy,
            fields: {
                site: false,
                route: false,
                qty: false,
                unit: false,
                ndc: false,
                lotNumber: false,
                statusOk: true,
            },
        };
    }

    // Field evaluations according to specification - only from medicationAdministration
    const sitePresent = isValuePresent(medAdmin?.site);
    const routePresent = isValuePresent(medAdmin?.route);
    const qtyPresent = isValuePresent(medAdmin?.dosage);
    const unitPresent = isValuePresent(medAdmin?.dosageUnit);
    const ndcPresent = isValuePresent(medAdmin?.medicationCode);
    const lotPresent = isValuePresent(medAdmin?.lotNumber);

    // Status rule: must NOT contain the keyword "complete" (case-insensitive)
    const hasStatusViolation = hasCompleteStatusKeyword(order.status);

    const hasAnyField =
        sitePresent || routePresent || qtyPresent || unitPresent || ndcPresent || lotPresent;
    const hasAllFields =
        sitePresent && routePresent && qtyPresent && unitPresent && ndcPresent && lotPresent;

    const hasAdminData = strategy === 'ALL' ? hasAllFields : hasAnyField;

    // Condition to block: order has administration data from eCW, OR status violates the rule
    const isBlocked = hasStatusViolation || hasAdminData;

    return {
        isBlocked,
        hasAdminData,
        hasStatusViolation,
        strategy,
        fields: {
            site: sitePresent,
            route: routePresent,
            qty: qtyPresent,
            unit: unitPresent,
            ndc: ndcPresent,
            lotNumber: lotPresent,
            statusOk: !hasStatusViolation,
        },
    };
};

export const isThinjOrderBlocked = (
    order: EcwOrder | null | undefined,
    strategy: 'ANY' | 'ALL' = THINJ_ADMIN_VALIDATION_STRATEGY
): boolean => {
    return checkThinjOrderAdministrationData(order, strategy).isBlocked;
};

export interface EcwManufacturerRecord {
    manufacturerId: string;
    manufacturerCode: string;
    name: string;
}

export interface ValidateManufacturerWithEcwResponse {
    status: number;
    message: string;
    success: boolean;
    errorDetails: any;
    result: EcwManufacturerRecord[];
}

export const ECW_THINJ_MANUFACTURER_NOT_AVAILABLE = "Scanned item's manufacturer name is not available in eCW.";
export const ECW_THINJ_MANUFACTURER_WARNING_MSG = "Scanned item's manufacturer name differs from eCW. Please select one to proceed.";
export const ECW_THINJ_MANUFACTURER_MULTIPLE_WARNING_MSG = "Scanned item's manufacturer name differs from eCW. Please select one to proceed.";
export const getEcwThinjManufacturerSingleWarningMsg = (ecw_manufacturer: string) => `Scanned item's manufacturer name differs from eCW. <strong>&ldquo;${ecw_manufacturer}&rdquo;</strong> will be use for this administration. Please continue to proceed or cancel to fix.`;
export const ECW_THINJ_MANUFACTURER_FIX_HINT = "Please fix the SRX item's manufacturer to avoid this warning in future.";

